// gioco/cartaMeme.ts — v037: la «foto per le Storie» di fine partita (Instagram, WhatsApp, TikTok accettano bene
// un'immagine verticale 9:16). La foto della risata in una polaroid storta, il titolo («Ho battuto Anna 🏆»), il
// marchio, il link e il suo codice QR. Tutto disegnato qui: niente servizi esterni.
import qrcode from "qrcode-generator";

const W = 1080;
const H = 1920;

function carica(src: string): Promise<HTMLImageElement | null> {
  return new Promise((ok) => {
    const i = new Image();
    i.decoding = "async";
    i.onload = () => ok(i);
    i.onerror = () => ok(null);
    i.src = src;
  });
}

function tondo(c: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, r: number): void {
  c.beginPath();
  c.moveTo(x + r, y);
  c.arcTo(x + w, y, x + w, y + h, r);
  c.arcTo(x + w, y + h, x, y + h, r);
  c.arcTo(x, y + h, x, y, r);
  c.arcTo(x, y, x + w, y, r);
  c.closePath();
}

/** Spezza il titolo in al massimo 3 righe che stanno in `larghezza`. */
function righe(c: CanvasRenderingContext2D, testo: string, larghezza: number): string[] {
  const parole = testo.split(/\s+/);
  const out: string[] = [];
  let riga = "";
  for (const p of parole) {
    const prova = riga ? `${riga} ${p}` : p;
    if (c.measureText(prova).width > larghezza && riga) {
      out.push(riga);
      riga = p;
    } else riga = prova;
  }
  if (riga) out.push(riga);
  return out.slice(0, 3);
}

export async function cartaMeme(d: { foto: string | null; titolo: string; sotto: string; link: string; carattere?: string }): Promise<Blob | null> {
  const tela = document.createElement("canvas");
  tela.width = W;
  tela.height = H;
  const c = tela.getContext("2d");
  if (!c) return null;
  const font = d.carattere || "system-ui, sans-serif";
  // fondo: blu e rosso come l'icona, con i raggi
  c.fillStyle = "#1870ec";
  c.fillRect(0, 0, W / 2, H);
  c.fillStyle = "#ea3422";
  c.fillRect(W / 2, 0, W / 2, H);
  c.save();
  c.translate(W / 2, H * 0.42);
  c.fillStyle = "rgba(255,255,255,0.09)";
  for (let k = 0; k < 24; k++) {
    c.rotate((Math.PI * 2) / 24);
    c.beginPath();
    c.moveTo(0, 0);
    c.lineTo(2200, -120);
    c.lineTo(2200, 120);
    c.closePath();
    if (k % 2 === 0) c.fill();
  }
  c.restore();
  const vel = c.createLinearGradient(0, 0, 0, H);
  vel.addColorStop(0, "rgba(14,10,36,0.15)");
  vel.addColorStop(1, "rgba(14,10,36,0.55)");
  c.fillStyle = vel;
  c.fillRect(0, 0, W, H);

  // titolo
  c.textAlign = "center";
  c.textBaseline = "alphabetic";
  c.font = `900 96px ${font}`;
  const t = righe(c, d.titolo, W - 140);
  t.forEach((r, i) => {
    const y = 210 + i * 108;
    c.lineWidth = 18;
    c.strokeStyle = "#1b1f4b";
    c.lineJoin = "round";
    c.strokeText(r, W / 2, y);
    c.fillStyle = "#ffd60a";
    c.fillText(r, W / 2, y);
  });

  // polaroid storta con la foto della risata
  const foto = d.foto ? await carica(d.foto) : null;
  c.save();
  c.translate(W / 2, 900);
  c.rotate(-0.05);
  c.shadowColor = "rgba(0,0,0,0.45)";
  c.shadowBlur = 40;
  c.shadowOffsetY = 18;
  c.fillStyle = "#ffffff";
  c.fillRect(-400, -400, 800, 860);
  c.shadowColor = "transparent";
  if (foto) {
    const lato = 720;
    const s = Math.max(lato / foto.naturalWidth, lato / foto.naturalHeight);
    const fw = foto.naturalWidth * s;
    const fh = foto.naturalHeight * s;
    c.save();
    c.beginPath();
    c.rect(-360, -360, lato, lato);
    c.clip();
    c.drawImage(foto, -fw / 2, -360 + (lato - fh) / 2, fw, fh);
    c.restore();
  } else {
    c.fillStyle = "#241a63";
    c.fillRect(-360, -360, 720, 720);
    c.font = `260px ${font}`;
    c.fillText("😂", 0, 90);
  }
  c.fillStyle = "#1b1f4b";
  c.font = `800 54px ${font}`;
  c.fillText(d.sotto.slice(0, 32), 0, 420);
  c.restore();

  // marchio, link e QR
  const icona = await carica("/icona-192.png");
  const y = 1480;
  if (icona) c.drawImage(icona, 120, y, 180, 180);
  c.textAlign = "left";
  c.fillStyle = "#ffffff";
  c.font = `900 64px ${font}`;
  c.fillText("Laughdown", 330, y + 80);
  // il link sta a sinistra del QR: si rimpicciolisce e, se serve, si accorcia con «…»
  c.fillStyle = "#ffe98a";
  const spazio = W - 120 - 240 - 14 - 330 - 24;
  let corpo = 40;
  let scritto = d.link.replace(/^https?:\/\//, "");
  c.font = `700 ${corpo}px ${font}`;
  while (c.measureText(scritto).width > spazio && corpo > 26) c.font = `700 ${(corpo -= 2)}px ${font}`;
  while (c.measureText(scritto).width > spazio && scritto.length > 8) scritto = `${scritto.slice(0, -2)}…`;
  c.fillText(scritto, 330, y + 140);
  try {
    const q = qrcode(0, "M");
    q.addData(d.link);
    q.make();
    const n = q.getModuleCount();
    const lato = 240;
    const m = lato / (n + 2);
    const x0 = W - 120 - lato;
    tondo(c, x0 - 14, y - 40, lato + 28, lato + 28, 26);
    c.fillStyle = "#ffffff";
    c.fill();
    c.fillStyle = "#0e0a24";
    for (let r = 0; r < n; r++) for (let k = 0; k < n; k++) if (q.isDark(r, k)) c.fillRect(x0 + (k + 1) * m, y - 26 + (r + 1) * m, Math.ceil(m), Math.ceil(m));
  } catch {
    // senza QR: resta il link scritto
  }
  return new Promise((ok) => tela.toBlob((b) => ok(b), "image/jpeg", 0.88));
}
